import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core"
import { useCallback } from "react"
import { getSelectedQuery } from "./config"
import { ViewType } from "./models"

export default function ViewSelect({
  title,
  value,
  options,
  onChangeView,
  isGmpUser,
}: {
  title: string
  value: string
  options: { value: string; label: string }[]
  onChangeView: (value: ViewType) => void
  isGmpUser: boolean
}) {
  const onChange = useCallback(
    (e) => {
      onChangeView(getSelectedQuery(e.target.value))
    },
    [onChangeView],
  )

  return (
    <FormControl style={{ height: "100%", alignSelf: "center" }}>
      <Box display="flex" alignItems="center">
        <Box marginRight="16px">
          <FormLabel
            style={{
              color: "var(--neutral-black, #000)",
              fontSize: 14,
              fontWeight: 700,
            }}
          >
            {title}
          </FormLabel>
        </Box>
        <RadioGroup value={value} onChange={onChange} row>
          {options.map((option) => (
            <FormControlLabel
              value={option.value}
              control={<Radio color="primary" style={{ fontSize: "13px" }} />}
              label={option.label}
              key={option.value}
              disabled={isGmpUser && option.value !== "gcf"}
            />
          ))}
        </RadioGroup>
      </Box>
    </FormControl>
  )
}
